<app-portal-collapsible
    icon="deactivate_account"
    title="Konto deaktivieren"
>
    <div class="grid-container vertical-gutter-lg m-8:b">
        <p class="g-12">
            Um dein Kundenkonto zu deaktivieren gib bitte dein aktuelles Passwort ein und klicke dann auf “Konto
            deaktivieren”.
        </p>
        <p class="g-12">
            Wenn dein Kundenkonto erfolgreich deaktiviert wurde wirst du sofort abgemeldet. Du kannst dich dann nicht
            wieder im Serviceportal anmelden.
        </p>
    </div>
    <form
        class=""
        [formGroup]="formGroup"
    >
        <div class="form-control">
            <label for="password-input">Passwort: </label>
            <input
                id="password-input"
                type="password"
                formControlName="password"
                placeholder="*********"
                autocomplete="new-password"
                [ctrlErrorMessage]="{
                    invalidPassword:
                        'Das Passwort ist nicht korrekt. Bitte überprüfe die Eingabe und versuche es erneut.',
                }"
            />
        </div>

        <div class="clearfix">
            <button
                class="button -red m-4:b float:right"
                type="submit"
                (click)="deactivateAccount()"
                [disabled]="formGroup.invalid || pending()"
            >
                <i ctrlIcon="deactivate_account"></i>
                <span class="fs:xs">Konto deaktivieren</span>
            </button>
        </div>
    </form>
</app-portal-collapsible>
